// Auth routes
export const LOGIN = "/connexion";
export const REGISTER = "/inscription";
export const FORGOT_PASSWORD = "/mot-de-passe-oublie";
export const RESET_PASSWORD = "/reinitialiser-mot-de-passe/:uid?/:token?";
export const VERIFICATION_OTP = "/verification-otp/:type?";

// App routes - Espace Agent
export const ESPACE_CNDJ = "/espace-cndj";
export const NUMERISATION = "/espace-cndj/numerisation";
export const DECISIONS = "/espace-cndj/decisions";
export const RECHERCHE = "/espace-cndj/recherche";

// App routes - Espace Admin
export const ESPACE_ADMIN = "/espace-admin";
export const ADMIN_UTILISATEURS = "/espace-admin/utilisateurs";
export const ADMIN_HISTORIQUE = "/espace-admin/historique";
